import { Typography } from '@mui/material';
import { get } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { dateFormat } from '../../../hooks';
import useStyles from './styles';

interface TestWaitProps {
  data: Record<string, any> | null;
}

export const TestWait: ComponentType<TestWaitProps> = ({ data }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const id = get(data, ['id']);
  const attestationDate = get(data, ['attestationDate'], new Date());
  const time = dateFormat(new Date(attestationDate), 'T');
  const date = dateFormat(new Date(attestationDate), 'D.M.Y');

  const text = id
    ? t(
        'attestation.wait.date',
        `Ожидайте. Тестирование будет запущено сотрудником аттестационного центра в ${time} ${date}`,
        {
          time,
          date,
        }
      )
    : t('attestation.noApprovedApplications', 'У вас нет подтвержденных заявок для аттестации');

  return (
    <>
      <Typography variant="h2" color="primary" mb={3}>
        {text}
      </Typography>
      <img src="/assets/wait.png" alt="" className={classes.waitImage} />
    </>
  );
};
